import { render, staticRenderFns } from "./MontoCard.vue?vue&type=template&id=667dc264&"
import script from "./MontoCard.vue?vue&type=script&lang=js&"
export * from "./MontoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports